import { styled } from "@mui/material/styles"

import { IconButton } from "../IconButton"

export const SidebarToolbar = styled("div")({
  width: "4.8rem",
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem"
})

export const SidebarToolbarLine = styled("hr")({
  borderTop: "0.1rem solid #79747E",
  width: "100%",
  height: 0,
  margin: 0
})

export const SidebarToolbarItem = styled(IconButton)({
  "&[class*=MuiIconButton-root]": {
    width: "4.8rem",
    height: "4.8rem"
  },
  "&.active": {
    backgroundColor: "#fff",
    boxShadow: "0 .05rem 2.15rem rgba(148, 116, 142, .31)"
  }
})
